import { LucideIcon } from 'lucide-react';
import { legacyTools } from './legacyTools';
import { discoveredTools } from './discoveredToolsRegistry';

export type ToolCategory = 'Text' | 'Image' | 'Dev' | 'Network' | 'Converters' | 'Media' | 'Calculator' | 'Science' | 'SEO' | 'Utility' | 'PDF' | 'Design' | 'Brain Games' | 'Fun' | 'Discovery' | 'Security' | 'Earth & Space' | 'Explore';

export interface Tool {
  id: string;
  name: string;
  description: string;
  category: ToolCategory;
  icon: LucideIcon | string;
  route: string;
  longDescription?: string;
  howToUse?: string[];
  benefits?: string[];
  faq?: { question: string; answer: string }[];
  metaTitle?: string;
  metaDescription?: string;
  keywords?: string[];
  image?: string;
  technicalDeepDive?: string;
  useCases?: string[];
  comparisonData?: { feature: string; vibeTools: string; others: string }[];
  expertNote?: string;
  relatedToolIds?: string[];
}

export const tools: Tool[] = [...legacyTools, ...discoveredTools];

export const categoryColors: Record<ToolCategory, string> = {
  Text: '#00FF94',
  Image: '#FF3366',
  Dev: '#FFD600',
  Converters: '#00D4FF',
  Media: '#AF52DE',
  Calculator: '#5856D6',
  SEO: '#34C759',
  Utility: '#FF2D55',
  PDF: '#FF3B30',
  Design: '#FF00FF',
  Network: '#0EA5E9',
  'Brain Games': '#9333EA',
  Science: '#10B981',
  Fun: '#F472B6',
  Discovery: '#A855F7',
  Security: '#EF4444',
  'Earth & Space': '#0EA5E9',
  Explore: '#8B5CF6'
};
